import { render, staticRenderFns } from "./FeedbackWrapper.vue?vue&type=template&id=6e5d8660&"
import script from "./FeedbackWrapper.vue?vue&type=script&lang=js&"
export * from "./FeedbackWrapper.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackWrapper.vue?vue&type=style&index=0&id=6e5d8660&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports